"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SelectWithRef = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _index = _interopRequireDefault(require("./index.styles"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//

/* eslint-disable react/prop-types */

/* prop-types not supported for forwardRef components */


var SelectWithRef = function SelectWithRef(props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_index["default"], (0, _extends2["default"])({
    ref: ref,
    classNamePrefix: "ReactSelect",
    isDisabled: props.disabled ? true : undefined
  }, props));
};
/* eslint-enable react/prop-types */


exports.SelectWithRef = SelectWithRef;
var Select = /*#__PURE__*/(0, _react.forwardRef)(SelectWithRef);
Select.propTypes = {
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object]),
    label: _propTypes.string
  })).isRequired,
  size: (0, _propTypes.oneOf)(['xs', 's', 'm', 'l', 'xl']),
  disabled: _propTypes.bool,
  isMulti: _propTypes.bool
};
Select.defaultProps = {
  size: 'm',
  disabled: false,
  isMulti: false
};
var _default = Select;
exports["default"] = _default;